import { render } from "./AdmTabs.vue?vue&type=template&id=7b8f28fb&scoped=true"
import script from "./AdmTabs.vue?vue&type=script&lang=js"
export * from "./AdmTabs.vue?vue&type=script&lang=js"

import "./AdmTabs.vue?vue&type=style&index=0&id=7b8f28fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8f28fb"]])

export default __exports__